import { DialogContent, ChangeDurationForm } from "@/components";

export interface ChangeDurationFormDialogProps {
    onClose?: () => void;
    existingLockAmount: number;
    existingDuration: number;
    selectedDuration?: number;
}

export function ChangeDurationFormDialog({
    existingLockAmount,
    existingDuration,
    selectedDuration,
}: ChangeDurationFormDialogProps) {
    return (
        <DialogContent className="max-w-[640px] relative">
            <ChangeDurationForm
                isDialog
                existingDuration={existingDuration}
                existingLockAmount={existingLockAmount}
                selectedDuration={selectedDuration}
            />
        </DialogContent>
    );
}
